<form [formGroup]="addForm" class="partner-add-form" (ngSubmit)="submit()">
  <div class="partner-add-form-header">
    <span class="partner-add-form-title">{{ 'partner.add.form.title' | translate : { fgbdefault: 'Add New Partner' } }}</span>
  </div>

  <div class="partner-add-form-fields">
    <div class="partner-add-form-field">
      <label class="partner-add-form-field-label" for="partner-add-fullname">{{
        'partner.add.fullname' | translate : { fgbdefault: 'Partner Full Name' }
      }}</label>
      <input id="partner-add-fullname" formControlName="fullName" type="text" class="partner-add-form-field-input" />
    </div>
    <div class="partner-add-form-field">
      <label class="partner-add-form-field-label" for="partner-add-email">{{
        'partner.add.form.email.label' | translate : { fgbdefault: 'Partner Email' }
      }}</label>
      <input id="partner-add-email" formControlName="email" type="text" class="partner-add-form-field-input" />
    </div>
  </div>

  <div class="partner-add-form-error">
    <fgbcl-errors></fgbcl-errors>
  </div>

  <div class="partner-add-form-actions">
    <button type="button" class="btn-text-danger" (click)="close(); $event.preventDefault()">
      {{ 'modal.cancel' | translate }}
    </button>
    <button type="submit" class="btn-filled-success" [disabled]="addForm.invalid">
      {{ 'modal.confirm' | translate }}
    </button>
  </div>
</form>
